import styled from 'styled-components';
import { defaultTheme } from '../../../../../../utils/defaultTheme';

export const MappingChartWrapper = styled.div`
    position: relative;
    width: fit-content;
    margin: 0 auto;

    /* Mapping Component */
    .mapping-tooltip {
        display: inline-flex;
        height: auto;
        margin: 0 auto;
        padding: 0.5rem;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        background: white;
        color: black;
        pointer-events: none;
        font-size: 0.7rem;
        box-shadow: 0px 0px 8px #00000026;

        h6 {
            text-align: center;
            font-size: 13px;
            color: ${defaultTheme.blue[800]};
            font-weight: 600;
            margin: 0px 2px 14px 0px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        h6.transitioned {
            color: ${defaultTheme.violet[500]} !important;
        }

        h6:before {
            content: '';
            display: inline-block;
            width: 9px;
            height: 9px;
            background: ${defaultTheme.blue[800]};
            transform: rotate(45deg);
            margin-left: 7px;
            margin-right: 7px;
        }
        h6.transitioned:before {
            background: ${defaultTheme.violet[500]};
        }

        p {
            font-size: 13px;
            margin: 0;
            color: ${defaultTheme.blue[800]};
        }
        p.transitioned {
            color: ${defaultTheme.violet[500]} !important;
        }
    }
    .mapping-tooltip:after {
        content: ' ';
        height: 0;
        position: absolute;
        width: 0;
        left: 95px;
        bottom: -6px;

        border: 10px solid transparent;
        border-top-color: white;
    }
    .mappingLabelGroup {
        padding: 4px 3px;
        box-sizing: border-box;
        display: flex;
        text-align: center;
    }
    .mappingLabelGroupText {
        margin: auto;
        font-weight: 600;
    }
`;
export const SvgContainer = styled.svg`
    position: relative;

    .mapping-tooltip-foreign-object {
        text-align: center;
        padding-top: 16px;
    }
`;

export const SectionTitleWrapper = styled.div`
    width: calc(100% - 180px);
    margin-left: 90px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap-reverse;
    justify-content: flex-start;
    align-items: stretch;
    align-content: stretch;
    margin-top: 50px;
`;
export const SectionDropdownWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: ${props => (props.isMappingChartUpdated ? '35%' : '45%')};
    min-width: 310px;
`;

export const ResetButton = styled.div`
    color: ${defaultTheme.blue[900]};
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    height: 20px;
    &:hover {
        background-color: ${defaultTheme.grey[50]};
    }
`;
export const DropdownWrapper = styled.div`
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`;

export const TitleWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    padding-top: 10px;
`;

export const SectionTitle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    margin-left: 10px;
`;
